import axios, { getAuthHeaders, getFormDataHeaders } from "./config";

export default {

    store: function(state) {
        return axios.post("/states", state, {
            headers: getFormDataHeaders(),
        });
    },
    show: function(stateID) {
        return axios.get(`/states/${stateID}`, {
            headers: getAuthHeaders()
        })
    },

    update: function(data) {
        return axios.put(`states/target-profile/${data.id}`, data, {
            headers: getAuthHeaders(),
        });
    },
};